<template>
  <b-card no-body class="mb-3 BabillardListItem">
    <b-card-img :src="img" :alt="title" class="BabillardListItem_Image" :top="isMobile" :left="!isMobile"
      @click="goToUrl(url)"></b-card-img>
    <b-card-body>
      <b-card-text class="BabillardListItem_Text" text-tag="div">
        <a :href="url" :alt="title" target="blank" class="BabillardListItem_Link">
          <span class="BabillardListItem_Title">{{ title }}</span>
        </a>
        <p class="BabillardListItem_Subtitle">{{ truncatedContent }}</p>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script lang="ts" setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';

const props = defineProps({
  img: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  content: {
    type: String,
    required: true
  },
  url: {
    type: String,
    required: true
  }
});

const isMobile = ref(false);

const setPosition = () => {
  isMobile.value = window.innerWidth < 768;
};

const goToUrl = (url: string) => {
  window.open(url, "_blank");
};

const truncatedContent = computed(() => {
  if (props.content.length > 300) {
    return props.content.trim().substring(0, 300) + '...';
  } else {
    return props.content.trim();
  }
});

onMounted(() => {
  setPosition();
  window.addEventListener('resize', setPosition);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setPosition);
});
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
@import "../../styles/mixins";

.BabillardListItem {
  @include border-radius(6px);
  height: auto;
  border: none;
  overflow: hidden;

  @media ($bp-min-md) {
    height: 150px;
    flex-direction: row;
  }

  @media ($bp-min-lg) {
    height: 260px;
  }

  &_Image {
    object-fit: cover;
    object-position: center center;
    cursor: pointer;
  }

  .card-img {
    &-left {
      height: 100%;
      width: 100%;
      min-width: 260px;
      max-width: 260px;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }

    &-top {
      height: 180px;
      width: auto;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
  }

  .card-body {
    max-width: 467px;
    padding-top: 15px;
    padding-bottom: 25px;
    padding-left: 20px;
    padding-right: 20px;
  }

  &_Link {
    position: relative;
    text-decoration: none;

    &:hover {
      &:before {
        opacity: 1;
        transition: opacity 0.2s ease-in-out;
      }
    }

    &:before {
      content: "";
      height: 1px;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
    }
  }

  &_Text {
    font-size: 14px;
    line-height: 18px;

    @media ($bp-min-md) {
      font-size: 16px;
      line-height: 21px;
      height: 100%;
      overflow: hidden;
    }
  }

  &_Title {
    color: $home-nav-color;
    font-family: $gt-haptik-bold;
    padding-bottom: 5px;
  }

  &_Subtitle {
    margin-bottom: 0;
    white-space: pre-line;
    overflow: hidden;
  }
}
</style>